function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { api } from './configs/axiosConfig';
import Cookies from 'js-cookie';
export var AuthorizationAPI = {
    getToken: function () {
        var _getToken = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var response;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            _context.n = 1;
                            return api.get("".concat(process.env.REACT_APP_API_URL, "/authentication/token"));
                        case 1:
                            response = _context.v;
                            return _context.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee);
        }));
        function getToken() {
            return _getToken.apply(this, arguments);
        }
        return getToken;
    }(),
    getUser: function () {
        var _getUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(userName) {
            var response;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return api.get("".concat(process.env.REACT_APP_API_URL, "/user?username=").concat(userName));
                        case 1:
                            response = _context2.v;
                            return _context2.a(2, response.data);
                    }
            }, _callee2);
        }));
        function getUser(_x) {
            return _getUser.apply(this, arguments);
        }
        return getUser;
    }(),
    getUserProfilePicture: function () {
        var _getUserProfilePicture = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return api.get("".concat(process.env.REACT_APP_API_URL, "/user/profile-picture"), {
                                validateStatus: function validateStatus() {
                                    return true;
                                }
                            });
                        case 1:
                            response = _context3.v;
                            return _context3.a(2, response.status === 200 ? response.data : null);
                    }
            }, _callee3);
        }));
        function getUserProfilePicture() {
            return _getUserProfilePicture.apply(this, arguments);
        }
        return getUserProfilePicture;
    }(),
    getPolicy: function () {
        var _getPolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var response;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return api.get("".concat(process.env.REACT_APP_API_URL, "/policy"));
                        case 1:
                            response = _context4.v;
                            return _context4.a(2, response.data);
                    }
            }, _callee4);
        }));
        function getPolicy() {
            return _getPolicy.apply(this, arguments);
        }
        return getPolicy;
    }(),
    refreshToken: function () {
        var _refreshToken = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var response;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.n) {
                        case 0:
                            if (!Cookies.get('refresh_token')) {
                                _context5.n = 2;
                                break;
                            }
                            _context5.n = 1;
                            return api.get("".concat(process.env.REACT_APP_API_URL, "/authentication/token/refresh"), {
                                headers: {
                                    refreshtoken: Cookies.get('refresh_token')
                                }
                            });
                        case 1:
                            response = _context5.v;
                            return _context5.a(2, response === null || response === void 0 ? void 0 : response.data);
                        case 2:
                            return _context5.a(2);
                    }
            }, _callee5);
        }));
        function refreshToken() {
            return _refreshToken.apply(this, arguments);
        }
        return refreshToken;
    }(),
    logout: function () {
        var _logout = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
            var response;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.n) {
                        case 0:
                            if (!Cookies.get('access_token')) {
                                _context6.n = 2;
                                break;
                            }
                            _context6.n = 1;
                            return api.post("".concat(process.env.REACT_APP_API_URL, "/authentication/logout"));
                        case 1:
                            response = _context6.v;
                            return _context6.a(2, response === null || response === void 0 ? void 0 : response.data);
                        case 2:
                            return _context6.a(2);
                    }
            }, _callee6);
        }));
        function logout() {
            return _logout.apply(this, arguments);
        }
        return logout;
    }(),
    logError: function () {
        var _logError = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7(data) {
            var response;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.n) {
                        case 0:
                            _context7.n = 1;
                            return api.post("".concat(process.env.REACT_APP_API_URL, "/error/logError"), data, {
                                skipErrorToast: true
                            });
                        case 1:
                            response = _context7.v;
                            return _context7.a(2, response.data);
                    }
            }, _callee7);
        }));
        function logError(_x2) {
            return _logError.apply(this, arguments);
        }
        return logError;
    }()
};
